import { getMorePosts } from "./ShowMorePosts";

const resourceFilterEl = document.getElementById('resource-filter');
let isLoading = false;

let resourceFilterState = {
  audience: [],
  category: [],
  topic: [],
};

if(resourceFilterEl) {
  window.addEventListener('resize', () => {
    adjustForHeight();
  });
  adjustForHeight();

  if (resourceFilterEl) {
    initResourceFilter(); 
    loadResults();
  }
}

function adjustForHeight() {
  if(resourceFilterEl.offsetHeight >= window.innerHeight - 160) {
    resourceFilterEl.classList.add('unstuck');
  }
  else {
    resourceFilterEl.classList.remove('unstuck');
  }
}

function initResourceFilter() {
  const resourceFilterCheckboxes = resourceFilterEl?.querySelectorAll('.resource-filter-checkbox');
  const clearAllButton = document.getElementById('filter-clear-all');
  const clearButtons = document.querySelectorAll('[data-filter-clear]');
  const filterToggles = document.querySelectorAll('[data-toggle="resource-filter"]');

  clearAllButton.addEventListener('click', clearAllFilters);
  for(let button of clearButtons) {
    button.addEventListener('click', (e) => clearFilterByName(e.target.dataset.filterClear));
  }

  for(let checkbox of resourceFilterCheckboxes) {
    checkbox.addEventListener('change', (e) => onChangeCheckbox(e.target));
  }

  for(let toggle of filterToggles) {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      resourceFilterEl.classList.toggle('is-open');
      // document.documentElement.classList.toggle('noscroll');
    });
  }

  setInitialState();
}

function setInitialState() {
  resourceFilterState = getFilterStateFromUrl();

  for(let filterKey of Object.keys(resourceFilterState)) {
    for(let term of resourceFilterState[filterKey]) {
      const filterEl = document.querySelector(`[name="${filterKey}"][value="${term}"]`);
      if (filterEl) {
        filterEl.checked = true;
      }
    }
  }
}

function getFilterStateFromUrl() {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const filterState = {
    audience: params.get('audience')?.split(',') || [],
    category: params.get('category')?.split(',') || [],
    topic: params.get('topic')?.split(',') || [],
  }

  return filterState;
}

function onChangeCheckbox(checkbox) {
  const filterName = checkbox.name;
  if(checkbox.checked) {
    addFilterTerm(filterName, checkbox.value);
  }
  else {
    removeFilterTerm(filterName, checkbox.value);
  }
  loadResults();
}

function addFilterTerm(filterName, term) {
  resourceFilterState[filterName].push(term);
  updateUrl();
}

function removeFilterTerm(filterName, term) {
  resourceFilterState[filterName] = resourceFilterState[filterName].filter(item => item !== term);
  updateUrl();
}

function updateUrl() {
  const url = new URL(window.location.href);
  const params = url.searchParams;

  for(let filterKey of Object.keys(resourceFilterState)) {
    if(resourceFilterState[filterKey].length > 0) {
      params.set(filterKey, resourceFilterState[filterKey].join(','));
    }
    else {
      params.delete(filterKey);
    }
  }

  window.history.replaceState({}, '', url);

  updateHeadings();
}

function updateHeadings() {
  const headingEl = document.getElementById('resource-head');
  const subHeadingEl = document.getElementById('resource-subhead');
  console.log(headingEl, subHeadingEl);

  const url = new URL(window.location.href);
  const params = url.searchParams;
  const audience_terms = params.get('category')?.split(',') || [];

  if(audience_terms.length === 1) {
    if(headingEl) {
      headingEl.textContent = window?.resources.plural_names[audience_terms[0]] || 'Resources';
      headingEl.classList.add('is-single-type');
    }
    subHeadingEl?.classList.add('is-single-type');
  }
  else {
    if(headingEl) {
      headingEl.textContent = 'Resources';
      headingEl.classList.remove('is-single-type');
    }
    subHeadingEl?.classList.remove('is-single-type');
  }

}

function clearFilterByName(filterName, shouldLoadMore = true) {
  let checkboxes = document.querySelectorAll(`[name="${filterName}"]`);
  for(let checkbox of checkboxes) {
    checkbox.checked = false;
  }
  resourceFilterState[filterName] = [];
  updateUrl();
  if(shouldLoadMore) {
    loadResults();
  }
}

function clearAllFilters() {
  for(let filterKey of Object.keys(resourceFilterState)) {
    clearFilterByName(filterKey, false);
  }
  loadResults();
}

function updateResourceMeta() {
  if(!window.resources) {
    return;
  }

  window.resources.page = 0;
  window.resources.tags = {...window.resources.tags, ...resourceFilterState};
}

function loadResults() {
  isLoading = true;
  updateResourceMeta();
  getMorePosts(true).then(() => {
    isLoading = false;
  });
}